import { stateGo } from 'redux-ui-router';

import {
  mapIsFavouriteWorkouts,
  selectFavouriteWorkoutIds,
  toggleFavouriteWorkout,
} from 'logic/favourite';

import {
  fetchMember,
  selectMember,
  selectSubscription,
  selectPrintTooltip,
} from 'logic/member';

import {
  fetchWorkout,
  selectWorkout,
  selectExercises,
  workoutPrintUri,
} from 'logic/workout';

export const Workout = {
  transclude: {
    navLeft: '?workoutNavLeft',
    header: '?workoutHeader',
  },

  template: `
    <div class="workout">
      <nav-page>
        <nav-left ng-transclude="navLeft"></nav-left>
        <nav-right>
          <button-print
            ng-hide="true"
            uri="{{ $ctrl.printUri }}"
            tooltip="$ctrl.tooltip"
            ng-click="$ctrl.refetchMember()"
            ng-if="$ctrl.subscription.canPrint">
          </button-print>
        </nav-right>
      </nav-page>
      <div ng-transclude="header">
      </div>
      <main class="main-content">
        <div class="container">
          <workout-intro
            title="$ctrl.workout.name"
            sub-title="$ctrl.workout.subTitle"
            description="$ctrl.workout.description"
            video-id="$ctrl.workout.introVideo.brightcoveId"
            ng-if="$ctrl.workout.introVideo.brightcoveId">
          </workout-intro>
          <div class="my-3" ng-hide="$ctrl.workout.introVideo.brightcoveId">
            <h3 ng-bind-html="$ctrl.workout.name"></h3>
            <h5 class="text-gray" ng-bind-html="$ctrl.workout.subTitle"></h5>
          </div>
          <div class="row flex-md-row-reverse"
            ng-if="!$ctrl.workout.playlistVideo">
            <div class="col-md-4">
              <div ng-hide="$ctrl.workout.introVideo.brightcoveId">
                <div class="img-wrapper mb-3">
                  <favourite-button
                    is-favourite="$ctrl.workout.isFavourite"
                    ng-if="$ctrl.workout.isFavourite !== undefined"
                    ng-click="$ctrl.toggleFavouriteWorkout({
                      memberId: $ctrl.member.id,
                      workoutId: $ctrl.workout.id,
                      isFavourite: $ctrl.workout.isFavourite
                    })">
                  </favourite-button>
                  <img class="img-fluid"
                    ng-src="{{ ($ctrl.workout.imageUrl.magazine || $ctrl.workout.image.magazine) | assetSrc }}" />
                </div>
                <div class="mb-3 d-flex justify-content-center">
                  <span class="mr-3">Member Rating:</span>
                  <rating-stars
                    size="md"
                    rating="$ctrl.workout.averageRating">
                  </rating-stars>
                </div>
                <div class="mb-3 d-flex justify-content-center">
                  <button-primary
                    on-click="$ctrl.stateGo('workoutPlayer', { exercisePlanId: $ctrl.params.exercisePlanId, id: $ctrl.params.id })"
                    ng-show="$ctrl.workout.autoplayable">
                    Start Workout</span>!
                  </button-primary>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <div class="d-flex align-items-center justify-content-between my-3"
                ng-show="$ctrl.workout.introVideo.brightcoveId">
                <h3>The Workout</h3>
                <button-primary
                  on-click="$ctrl.stateGo('workoutPlayer', { exercisePlanId: $ctrl.params.exercisePlanId, id: $ctrl.params.id })"
                  ng-show="$ctrl.workout.autoplayable">
                  Start <span class="d-none d-md-inline">Workout</span>!
                </button-primary>
              </div>
              <workout-list
                exercises="$ctrl.exercises"
                member="$ctrl.member"
                params="$ctrl.params"
                workout="$ctrl.workout">
              </workout-list>
              <div class="my-5"
                ng-if="$ctrl.subscription.isWeekly && $ctrl.workout.id">
                <reviews
                  wording-plural="Reviews"
                  wording-rating="Rate this Exercise Plan"
                  wording-singular="Review"
                  reviewable-type="ExercisePlanDayV2"
                  reviewable-id="$ctrl.workout.id">
                </reviews>
              </div>
            </div>
          </div>
          <video-playlist
            ng-if="$ctrl.workout.playlistVideo"
            list="$ctrl.workout.playlistVideo.items"
            autoplay="false"
            continuous="true"
            loop="false">
          </video-playlist>
        </div>
      </main>
    </div>`,

  controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);
        this.fetchWorkout(this.exercisePlanId, this.id);
      },

      $onDestroy() {
        this.unsubscribe();
      },

      refetchMember() {
        this.tooltip && $timeout(() => this.fetchMember(this.member.id), 500);
      },

      setDemo(exercise) {
        this.demo = {
          id: exercise.video.brightcoveId,
          title: exercise.name,
        };
      },

      mapState({ favourite, member, router, workout }) {
        const { exercisePlanId, id } = router.currentParams;
        const subscription = selectSubscription(member);

        return {
          exercisePlanId,
          id,
          subscription,
          tooltip: selectPrintTooltip(member),
          printUri: workoutPrintUri(
            id,
            exercisePlanId,
            subscription && subscription.id
          ),
          exercises: selectExercises(workout),
          member: selectMember(member),
          params: { exercisePlanId, id },
          workout: mapIsFavouriteWorkouts(
            selectWorkout(workout, id),
            selectFavouriteWorkoutIds(favourite)
          ),
        };
      },

      mapDispatch() {
        return {
          toggleFavouriteWorkout,
          stateGo,
          fetchMember,
          fetchWorkout,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Workout.js